import type {
  CompetitorService,
  CompetitorServiceCreateRequest,
  CompetitorServiceDetail,
  CompetitorServiceList,
  CompetitorServicePatchRequest,
  CompetitorServiceReferralSetting,
  CompetitorServiceReferralSettingCreateRequest,
  CompetitorServiceReferralSettingPatchRequest,
  CompetitorServiceSalesMaterial,
  CompetitorServiceSalesMaterialCreateRequest,
  CompetitorServiceSalesMaterialList,
  CompetitorServiceSalesMaterialUpdateRequest,
} from "@shared/types/competitor-service";
import { api } from "./client";

/// 競合サービス名寄せマスタの読み取り。 customer / product の競合サービス
/// モーダルで選択肢候補に使う。
export const competitorServicesApi = {
  list(): Promise<CompetitorServiceList> {
    return api.get<CompetitorServiceList>("/api/competitor-services");
  },
  get(id: string): Promise<CompetitorServiceDetail> {
    return api.get<CompetitorServiceDetail>(
      `/api/competitor-services/${encodeURIComponent(id)}`,
    );
  },
  create(body: CompetitorServiceCreateRequest): Promise<CompetitorService> {
    return api.post<CompetitorService>("/api/competitor-services", body);
  },
  patch(
    id: string,
    body: CompetitorServicePatchRequest,
  ): Promise<CompetitorService> {
    return api.patch<CompetitorService>(
      `/api/competitor-services/${encodeURIComponent(id)}`,
      body,
    );
  },
  delete(id: string): Promise<void> {
    return api.delete(`/api/competitor-services/${encodeURIComponent(id)}`);
  },
  createReferralSetting(
    id: string,
    body: CompetitorServiceReferralSettingCreateRequest,
  ): Promise<CompetitorServiceReferralSetting> {
    return api.post<CompetitorServiceReferralSetting>(
      `/api/competitor-services/${encodeURIComponent(id)}/referral-setting`,
      body,
    );
  },
  patchReferralSetting(
    id: string,
    body: CompetitorServiceReferralSettingPatchRequest,
  ): Promise<CompetitorServiceReferralSetting> {
    return api.patch<CompetitorServiceReferralSetting>(
      `/api/competitor-services/${encodeURIComponent(id)}/referral-setting`,
      body,
    );
  },
  deleteReferralSetting(id: string): Promise<void> {
    return api.delete(
      `/api/competitor-services/${encodeURIComponent(id)}/referral-setting`,
    );
  },
  listSalesMaterials(id: string): Promise<CompetitorServiceSalesMaterialList> {
    return api.get<CompetitorServiceSalesMaterialList>(
      `/api/competitor-services/${encodeURIComponent(id)}/sales-materials`,
    );
  },
  createSalesMaterial(
    id: string,
    body: CompetitorServiceSalesMaterialCreateRequest,
  ): Promise<CompetitorServiceSalesMaterial> {
    return api.post<CompetitorServiceSalesMaterial>(
      `/api/competitor-services/${encodeURIComponent(id)}/sales-materials`,
      body,
    );
  },
  updateSalesMaterial(
    id: string,
    materialId: string,
    body: CompetitorServiceSalesMaterialUpdateRequest,
  ): Promise<CompetitorServiceSalesMaterial> {
    return api.patch<CompetitorServiceSalesMaterial>(
      `/api/competitor-services/${encodeURIComponent(id)}/sales-materials/${encodeURIComponent(materialId)}`,
      body,
    );
  },
  deleteSalesMaterial(id: string, materialId: string): Promise<void> {
    return api.delete(
      `/api/competitor-services/${encodeURIComponent(id)}/sales-materials/${encodeURIComponent(materialId)}`,
    );
  },
};
